window.copyState = true;
$(function () {
	$B.on('click','.js-copy',function (e) {
		copyState = false;
		selectElementContents(document.getElementById('policycheck_result'))
	});

	function selectElementContents(el) {
		const body = document.body;
		let range;
		let sel;

		if (document.createRange && window.getSelection) {
			range = document.createRange();
			sel = window.getSelection();
			sel.removeAllRanges();
			try {
				range.selectNodeContents(el);
				sel.addRange(range);
			} catch (e) {
				range.selectNode(el);
				sel.addRange(range);
			}
		} else if (body.createTextRange) {
			range = body.createTextRange();
			range.moveToElementText(el);
			range.select();
		}
		document.execCommand('copy');
		copyState = true;
	}

	$('[data-action-callback="get_policy_info"]').on('submit',function () {
		setTimeout(function () {
			$('.js-copy').fadeIn();
		},2000);
	});

	$B.on('DOMSubtreeModified', "#policycheck_result", function() {
		setTimeout(function () {
			$('.pc-info').css('width','700px');
		},1000);
	});
});
